import React from 'react';

import { Route, Switch } from 'react-router-dom';

import Home from '../pages/Home';
import Catalog from '../pages/Catalog';
import Detail from '../pages/detail/Detail';
import ContactUs from '../pages/ContactUs';
import Terms from '../pages/Terms';

const Routes = () => {
    return (
        <Switch>
            <Route 
                path="/terms" 
                component={Terms} 
            />
            <Route 
                path="/contact" 
                component={ContactUs} 
            />
            <Route
                path='/:category/search/:keyword'
                component={Catalog}
            />
            <Route
                path='/:category/:id'
                component={Detail}
            />
            <Route
                path='/:category'
                component={Catalog}
            />
            <Route
                path='/'
                exact
                component={Home}
            />
        </Switch>
    );
}

export default Routes;
